import {Reducer} from "redux";
import {ACTION_TYPES} from "../actions";
import {loadLayerData} from "./loadLayerData";
import {loadMapStyle} from "./loadMapStyle";
import {toggleLayerVisibility} from "./toggleLayerVisibility";
import {IApplicationState} from "../types";
import {fromJS} from "immutable";
import {selectFeature} from "./selectFeature";
import {selectFeatures} from "./selectFeatures";
import {updateLayer} from "./updateLayer";
import {updateEntity} from "./updateEntity";
import {deleteEntity} from "./deleteEntity";
import {createFeature} from "./createFeature";
import {loadLayerMetadata} from "./loadLayerMetadata";
import {createNewLayer} from "./createNewLayer";
import {deleteLayer} from "./deleteLayer";
import {createMeasurementLayer} from "./createMeasurementLayer";
import {setSinglePoint} from "./setSinglePoint";
import {loadLayerDataCompleted} from "./loadLayerDataCompleted";


const INITIAL_STATE: IApplicationState['map'] = {
    styleName: '',
    styleLoaded: false,
    layersLoaded: false,
    isLoading: false,
    pendingRequests: 0,
    mapStyle : fromJS(
        {
            layers: [],
            sources: {},
        }
    ),
    layerState: {},
    layerIds: [],
    measureLayerIds: [],
    databaseLayerIds: {},
    layerNamesByType: {},
    layersByType: {},
};

const reducer: Reducer<IApplicationState['map']> = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ACTION_TYPES.FETCH_STYLE:
            return {...state, isLoading: true, pendingRequests: state.pendingRequests++};
        case ACTION_TYPES.FETCH_LAYERS_SUCCESS:
            return loadLayerMetadata(state, action);
        case ACTION_TYPES.FETCH_GEOMETRY_LAYER_SUCCESS:
            return loadLayerData(state, action);
        case ACTION_TYPES.FETCH_ALL_GEOMETRY_LAYER_SUCCESS:
            return loadLayerDataCompleted(state, action);
        case ACTION_TYPES.FETCH_STYLE_SUCCESS:
            return loadMapStyle(state, action);
        case ACTION_TYPES.TOGGLE_LAYER_VISIBILITY:
            return toggleLayerVisibility(state, action);
        case ACTION_TYPES.CREATE_MEASUREMENT_LAYER:
            return createMeasurementLayer(state, action);
        case ACTION_TYPES.SET_SINGLE_POINT:
            return setSinglePoint(state, action);
        case ACTION_TYPES.SELECT_FEATURE:
            return selectFeature(state, action);
        case ACTION_TYPES.SELECT_FEATURES:
            return selectFeatures(state, action);
        case ACTION_TYPES.UPDATE_LAYER:
        case ACTION_TYPES.UPDATE_ENTITY:
            return {...state, isLoading: true, pendingRequests: state.pendingRequests++};
        case ACTION_TYPES.UPDATE_LAYER_SUCCESS:
            return updateLayer(state, action);
        case ACTION_TYPES.DELETE_LAYER_SUCCESS:
            return deleteLayer(state, action);
        case ACTION_TYPES.UPDATE_ENTITY_GEOMETRY_SUCCESS:
        case ACTION_TYPES.UPDATE_ENTITY_SUCCESS:
            return updateEntity(state, action);
        case ACTION_TYPES.DELETE_ENTITY_SUCCESS:
            return deleteEntity(state, action);
        case ACTION_TYPES.CREATE_POINT_SUCCESS:
        case ACTION_TYPES.CREATE_POLYGON_SUCCESS:
        case ACTION_TYPES.CREATE_ENTITY_GEOMETRY_SUCCESS:
            return createFeature(state, action);
        case ACTION_TYPES.CREATE_LAYER_SUCCESS:
            return createNewLayer(state, action);
        default: {
            return state
        }
    }
};

export { reducer as MapReducer };
